import ReactLoading from 'react-loading';

const LoadingSpinner = () => (
  <div className="flex justify-center items-center h-full">
    <ReactLoading type="spin" className="text-primary-600" height={50} width={50} />
  </div>
);

export default LoadingSpinner;
